import { homologationConstants } from '../_constants';

export function insertTramite(state = {}, action) {
  switch (action.type) {
    case homologationConstants.INSERT_REQUEST:
      return { registering: true };
    case homologationConstants.INSERT_SUCCESS:
      return {};
    case homologationConstants.INSERT_FAILURE:
      return {};
    default:
      return state
  }
}